import React, { useEffect, useState, useContext } from "react";
import { Button, Container, Form, Input } from "reactstrap";
import "./style.css";
import Slider from "react-slick";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../config.json";
import classes from "../../components/common/Admin/style.module.css";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { Box, LinearProgress, Modal, Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import LoadingSpinner from "../../components/common/Admin/common/LoadingSpinner";
import { GlobalContext } from "../../components/layouts/UserLayout";
import { getServices, postServices } from "../../apiServices/apiServices";
import toast from "react-hot-toast";
import { IoChevronBackOutline } from "react-icons/io5";
import NoInternetComp from "../../components/common/InternetConnetction/NoInternetComp";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

function ProductDetails() {
  const location = useLocation();
  const [data, setData] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const url = config.url;
  const [sliderRef, setSliderRef] = useState(null);
  const [ratingsData, setRatingsData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const access_token = localStorage.getItem("user-access-token");
  const global_context = useContext(GlobalContext);

  const [variationData, setVariationData] = useState(); // selected color object
  const [sizeSelection, setSizeSelection] = useState(); // selected size object
  const [colorId, setColorId] = useState();
  const [selectedBranding, setSelectedBranding] = useState(null);

  const navigate = useNavigate();
  const [loginModal, setIsLoginModal] = useState(false);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (current, next) => setCurrentImageIndex(next),
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    padding: "20px 14px",
    outline: "none",
    borderRadius: "10px",
  };

  useEffect(() => {
    if (navigator.onLine) {
      fetchSingleProductDetails();
      fetchRatings();
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [navigator]);

  // retrieving ip and sending to db
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => {
        postCreateActivity(data);
      })
      .catch((err) => console.error(err));
  }, []);

  const postCreateActivity = async (ipData) => {
    try {
      const res = await postServices(`/api/ip/create-activity`, "", {
        ip: ipData.ip,
        event_type: 2,
        product_id: location.state.product_id,
      });

      if (res.responseCode !== 200) {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSingleProductDetails = async () => {
    setIsLoading(true);
    try {
      const res = await getServices(
        `/api/products/details/${location.state.product_id}`
      );
      setIsLoading(false);
      if (res.responseCode === 200) {
        const product = res.responseData;
        setData([product]);

        const firstColor = product.productColorInfo?.[0] || null;
        setVariationData(firstColor);
        setColorId(firstColor?.product_color_id);

        const firstSize = firstColor?.productDataInfo?.[0] || null;
        setSizeSelection(firstSize);

        const firstBranding = firstSize?.brandings?.[0] || null;
        setSelectedBranding(firstBranding);

        setCurrentImageIndex(0);
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error);
    }
  };

  const fetchRatings = async () => {
    setIsLoading(true);
    try {
      const res = await getServices(
        `/api/review/list_review/${location.state.product_id}`
      );
      setIsLoading(false);
      if (res.responseCode === 200) {
        setRatingsData(res.responseData);
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error);
    }
  };

  const handleAddToCart = async () => {
    if (!sizeSelection) {
      toast.error("Please select size..!");
      return;
    }
    if (!selectedBranding) {
      toast.error("Please select branding..!");
      return;
    }

    try {
      const res = await postServices(`/api/cart/add_cart`, access_token, {
        product_id: data[0].product_id,
        color_id: colorId,
        variation_id: sizeSelection.product_data_id,
        branding_id: selectedBranding.branding_id,
      });
      if (res.responseCode === 200) {
        toast.success("Product added to Cart successfully...");
        global_context.fetchCartData();
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  // COLOR CLICK – receives full productColorInfo item
  const handleVariationClick = (color) => {
    setVariationData(color);
    setColorId(color.product_color_id);

    const firstSize = color.productDataInfo?.[0] || null;
    setSizeSelection(firstSize);

    const firstBranding = firstSize?.brandings?.[0] || null;
    setSelectedBranding(firstBranding || null);

    setCurrentImageIndex(0);
  };

  // SIZE CLICK – receives size object from productDataInfo
  const handleSizeClick = (e, size) => {
    e.preventDefault();
    setSizeSelection(size);
    setCurrentImageIndex(0);

    if (size.brandings && size.brandings.length > 0) {
      setSelectedBranding(size.brandings[0]);
    } else {
      setSelectedBranding(null);
    }
  };

  const handleBrandingClick = (branding) => {
    setSelectedBranding(branding);
  };

  const handleBackButton = () => {
    navigate(-1);
  };

  const handleGuestModeCart = () => {
    setIsLoginModal(true);
  };

  const handleLoginPage = () => {
    navigate("/login");
  };

  const handleCheckAvailability = (e) => {
    e.preventDefault();
  };

  const currentImages = sizeSelection?.image || [];

  return (
    <>
      <Container className="pt-2">
        {navigator.onLine ? (
          <Container>
            {isLoading ? (
              <Container className="flex items-center justify-center mt-52">
                <LoadingSpinner />
              </Container>
            ) : (
              <Container className="pb-4 px-4 sm:px-8">
                {data.length <= 0 ? (
                  <Container className="flex justify-center items-center h-[65vh] flex-col">
                    <p className="font-semibold">No Data Found...</p>
                  </Container>
                ) : (
                  <Container>
                    <Container className="relative z-10">
                      <Button
                        className="py-1 px-4 rounded-full flex items-center gap-2"
                        onClick={handleBackButton}
                      >
                        <IoChevronBackOutline className="text-2xl cursor-pointer" />
                        <p className="font-semibold text-lg">Product Details</p>
                      </Button>
                    </Container>

                    <Container className="product-details-cards">
                      {/* LEFT CARD: IMAGES */}
                      <Container className="product-details-first-card pr-2">
                        <Container className="p-5 bg-white rounded-xl shadow-lg sticky top-28 bottom-0">
                          {/* Main image */}
                          <Container className="relative mb-4">
                            {currentImages[currentImageIndex] && (
                              <Zoom>
                                <img
                                  src={url + currentImages[currentImageIndex]}
                                  className="rounded-2xl object-contain w-full h-72 sm:h-[450px]"
                                  alt="Product"
                                />
                              </Zoom>
                            )}
                            {currentImages.length > 0 && (
                              <div
                                style={{
                                  backgroundColor: "#161c247a",
                                  color: "#ffffff",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  borderRadius: "8px",
                                  padding: "2px",
                                  position: "absolute",
                                  top: "25px",
                                  left: "40px",
                                }}
                              >
                                <button
                                  onClick={sliderRef?.slickPrev}
                                  className="px-2 outline-none border-none"
                                >
                                  <MdArrowBackIos />
                                </button>
                                {currentImageIndex + 1} / {currentImages.length}
                                <button
                                  onClick={sliderRef?.slickNext}
                                  className="px-2 outline-none border-none"
                                >
                                  <MdArrowForwardIos />
                                </button>
                              </div>
                            )}
                          </Container>

                          {/* Thumbnails */}
                          <Container className="flex flex-col gap-4 items-end my-6 text-right pl-2">
                            <Slider
                              {...settings}
                              ref={setSliderRef}
                              className="max-w-xs mx-auto w-96"
                            >
                              {currentImages.map((item, index) => (
                                <div
                                  key={index}
                                  className={`${classes.thumbnail} outline-none`}
                                  onClick={() => setCurrentImageIndex(index)}
                                >
                                  <img
                                    src={url + item}
                                    alt={`Thumbnail ${index + 1}`}
                                    className={`${
                                      currentImageIndex === index
                                        ? classes.active
                                        : ""
                                    } object-cover`}
                                    style={{
                                      height: "60px",
                                      width: "80px",
                                      borderRadius: "16px",
                                    }}
                                  />
                                </div>
                              ))}
                            </Slider>
                          </Container>
                        </Container>
                      </Container>

                      {/* RIGHT CARD: DETAILS */}
                      <Container className="product-details-second-card">
                        <Container className="mt-6 lg:mt-0 p-5 bg-white rounded-xl shadow-lg mb-6 sm:mb-3">
                          {data.map((item, i) => (
                            <Container key={i}>
                              <p className="font-semibold capitalize text-xl mb-3">
                                {item.product_name}
                              </p>

                              {ratingsData?.noOfRatings > 0 && (
                                <Container className="flex items-center mb-3">
                                  <Rating
                                    name="half-rating-read"
                                    defaultValue={
                                      ratingsData ? ratingsData.totalRatings : 0
                                    }
                                    value={
                                      ratingsData ? ratingsData.totalRatings : 0
                                    }
                                    precision={0.1}
                                    readOnly
                                    sx={{ color: "#faaf00" }}
                                    emptyIcon={
                                      <StarIcon style={{ opacity: 0.55 }} />
                                    }
                                    className="mr-3"
                                  />
                                  <p
                                    style={{ color: "#919eab" }}
                                    className="text-sm"
                                  >
                                    ({ratingsData?.noOfRatings} reviews)
                                  </p>
                                </Container>
                              )}

                              {/* PRICE */}
                              <Container className="flex items-end mb-3">
                                {data && (
                                  <h1
                                    className="text-3xl font-bold"
                                    style={{
                                      marginRight:
                                        sizeSelection?.sales_price == 0
                                          ? "0"
                                          : "1rem",
                                      color:
                                        sizeSelection?.sales_price == 0
                                          ? ""
                                          : "red",
                                    }}
                                  >
                                    {sizeSelection?.sales_price == 0 ||
                                    sizeSelection?.sales_price == null
                                      ? null
                                      : "₹ " + sizeSelection?.sales_price}
                                  </h1>
                                )}
                                {data && (
                                  <h1
                                    className="text-xl font-bold"
                                    style={{
                                      color:
                                        sizeSelection?.sales_price == 0 ||
                                        sizeSelection?.sales_price == null
                                          ? "red"
                                          : "#64748B",
                                      fontSize:
                                        sizeSelection?.sales_price == 0 ||
                                        sizeSelection?.sales_price == null
                                          ? "1.875rem"
                                          : "1.25rem",
                                      lineHeight: sizeSelection?.sales_price
                                        ? "1.75rem"
                                        : "2.25rem",
                                    }}
                                  >
                                    {sizeSelection?.sales_price == 0 ||
                                    sizeSelection?.sales_price == null ? (
                                      "₹ " + sizeSelection?.price
                                    ) : (
                                      <del>{"₹ " + sizeSelection?.price}</del>
                                    )}
                                  </h1>
                                )}
                                {data && sizeSelection?.offer_value > 0 && (
                                  <p className="ml-3 text-md font-semibold text-green-600">
                                    {sizeSelection.offer_value + "% OFF"}
                                  </p>
                                )}
                              </Container>

                              <p className="min-w-[160px] text-[#637381e3] mb-3 text-justify">
                                {item?.description}
                              </p>

                              {/* COLOR SELECTION */}
                              <Container className="bg-[#fff5de] p-4 mb-3 rounded">
                                <p className="font-semibold text-sm mb-2">
                                  Select Color
                                </p>
                                <Container className="flex gap-2 flex-wrap items-center text-center">
                                  {data[0]?.productColorInfo?.map(
                                    (clr, idx) => (
                                      <Container
                                        key={idx}
                                        onClick={
                                          colorId === clr.product_color_id
                                            ? null
                                            : () => handleVariationClick(clr)
                                        }
                                        className={`text-center cursor-pointer capitalize rounded-md ${
                                          colorId === clr.product_color_id
                                            ? "border-2 border-slate-500 opacity-100"
                                            : "opacity-50"
                                        }`}
                                      >
                                        <img
                                          src={
                                            url +
                                            (clr.productDataInfo?.[0]
                                              ?.image?.[0] || "")
                                          }
                                          alt={clr.colors}
                                          className="w-16 rounded-md h-10 object-cover"
                                        />
                                        <p className="text-xs">{clr.colors}</p>
                                      </Container>
                                    )
                                  )}
                                </Container>
                              </Container>

                              {/* SIZE SELECTION */}
                              {variationData?.productDataInfo &&
                                variationData.productDataInfo.length > 0 && (
                                  <Container className="bg-[#f1f5f9] p-4 mb-3 rounded mt-2">
                                    <p className="font-semibold text-sm mb-2">
                                      Select Size (breadth x length) in cm
                                    </p>
                                    <Container className="flex flex-wrap gap-2">
                                      {variationData.productDataInfo.map(
                                        (size) => (
                                          <button
                                            key={size.product_data_id}
                                            onClick={(e) =>
                                              handleSizeClick(e, size)
                                            }
                                            className={`px-3 py-1 rounded-full text-xs border ${
                                              sizeSelection?.product_data_id ===
                                              size.product_data_id
                                                ? "bg-[#800000] text-white border-[#800000]"
                                                : "border-slate-300 text-slate-700 bg-white"
                                            }`}
                                          >
                                            {size.breadth_in_mm} x{" "}
                                            {size.length_in_mm}
                                          </button>
                                        )
                                      )}
                                    </Container>
                                  </Container>
                                )}

                              {/* BRANDING SELECTION */}
                              {sizeSelection?.brandings &&
                                sizeSelection.brandings.length > 0 && (
                                  <Container className="bg-[#f1f5f9] p-4 mb-3 rounded mt-2">
                                    <p className="font-semibold text-sm mb-2">
                                      Select Branding
                                    </p>
                                    <Container className="flex flex-wrap gap-2">
                                      {sizeSelection.brandings.map((brand) => (
                                        <button
                                          key={brand.branding_id}
                                          onClick={() =>
                                            handleBrandingClick(brand)
                                          }
                                          className={`px-3 py-1 rounded-full text-xs border ${
                                            selectedBranding?.branding_id ===
                                            brand.branding_id
                                              ? "bg-[#800000] text-white border-[#800000]"
                                              : "border-slate-300 text-slate-700 bg-white"
                                          }`}
                                        >
                                          {brand.name}
                                        </button>
                                      ))}
                                    </Container>

                                    {selectedBranding && (
                                      <p className="mt-2 text-xs text-slate-600">
                                        Selected branding:{" "}
                                        <span className="font-semibold">
                                          {selectedBranding.name}
                                        </span>
                                      </p>
                                    )}
                                  </Container>
                                )}

                              {/* MOQ */}
                              {sizeSelection && (
                                <p className="mb-3 text-sm text-red-500 bg-red-200 w-fit py-1 px-4 rounded-full">
                                  {`Minimum order quantity: ${
                                    sizeSelection.moq || 100
                                  }`}
                                </p>
                              )}

                              {/* ADD TO CART */}
                              <Container className="mb-3 flex justify-between">
                                <Button
                                  className="bg-[#800000] outline-none text-white font-semibold py-3 px-8 rounded-xl active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
                                  onClick={
                                    access_token
                                      ? () => handleAddToCart()
                                      : () => handleGuestModeCart()
                                  }
                                >
                                  Add to Cart
                                </Button>
                              </Container>

                              <hr className="border-dashed border-[#800000] mb-3" />

                              {/* PRODUCT INFO */}
                              <h2 className="font-semibold mb-4">
                                Product Info
                              </h2>
                              <Container className="flex justify-between w-full text-sm items-start mb-3">
                                <h2 className="font-semibold">Category</h2>
                                <p className="capitalize text-right w-[50%]">
                                  {item.categoryInfo
                                    ?.map((category) => category.category_name)
                                    .join(", ")}
                                </p>
                              </Container>

                              {/* {item.subcatInfo?.subcat_name && (
                                <Container className="flex text-sm justify-between w-full items-center mb-3">
                                  <h2 className="font-semibold">
                                    Sub-Category
                                  </h2>
                                  <p>{item.subcatInfo?.subcat_name}</p>
                                </Container>
                              )} */}

                              {sizeSelection?.weight && (
                                <Container className="flex text-sm justify-between w-full items-center mb-3">
                                  <h2 className="font-semibold">
                                    Weight(approx.)
                                  </h2>
                                  <p>{sizeSelection.weight} kg</p>
                                </Container>
                              )}

                              {(sizeSelection?.length_in_mm ||
                                sizeSelection?.breadth_in_mm) && (
                                <Container className="flex text-sm justify-between w-full items-center mb-3">
                                  <h2 className="font-semibold">
                                    Length X Breadth (cm)
                                  </h2>
                                  <p>
                                    {sizeSelection.length_in_mm} X{" "}
                                    {sizeSelection.breadth_in_mm}
                                  </p>
                                </Container>
                              )}

                              {sizeSelection?.taxInfo && (
                                <Container className="flex text-sm justify-between w-full items-center mb-3">
                                  <h2 className="font-semibold">
                                    GST info (CGST/SGST)
                                  </h2>
                                  <p>
                                    {sizeSelection?.taxInfo?.tax_name +
                                      " (" +
                                      sizeSelection?.taxInfo?.cgst +
                                      "/" +
                                      sizeSelection?.taxInfo?.sgst +
                                      ")"}
                                  </p>
                                </Container>
                              )}

                              <hr className="border-dashed border-[#800000] mb-3" />

                              <h2 className="font-semibold mb-4">
                                Product Description
                              </h2>
                              <p
                                className="text-xs text-justify mb-3 prose prose-gray max-w-none"
                                dangerouslySetInnerHTML={{
                                  __html: item.product_feature,
                                }}
                              />
                            </Container>
                          ))}
                          <hr className="border-dashed border-[#800000] mb-4" />

                          {/* RATINGS SECTION (unchanged from your original) */}
                          {ratingsData?.noOfRatings > 0 && (
                            <Container>
                              <p className="font-semibold">Ratings</p>
                              <Container className="grid grid-cols-3">
                                <Container className="flex flex-col col-span-1 items-center justify-center gap-2 sm:gap-4">
                                  <h6 className="font-semibold text-sm sm:text-base">
                                    Average Rating
                                  </h6>
                                  <h2 className="text-xl sm:text-3xl font-bold">
                                    {ratingsData
                                      ? ratingsData.totalRatings
                                      : ""}{" "}
                                    /5
                                  </h2>
                                  <Rating
                                    name="half-rating-read"
                                    value={
                                      ratingsData ? ratingsData.totalRatings : 0
                                    }
                                    precision={0.1}
                                    readOnly
                                    sx={{ color: "#faaf00" }}
                                    emptyIcon={
                                      <StarIcon style={{ opacity: 0.55 }} />
                                    }
                                  />
                                  <p className="text-zinc-400">
                                    ({ratingsData ? ratingsData.noOfRatings : 0}{" "}
                                    reviews)
                                  </p>
                                </Container>
                                <Container className="flex flex-col col-span-2 ml-4 gap-2 px-0 md:px-10 py-5 md:border-dashed md:border-[#800000] md:border-l">
                                  {[5, 4, 3, 2, 1].map((star) => (
                                    <Container
                                      className="flex items-center flex-row"
                                      key={star}
                                    >
                                      <span className="m-0 font-semibold w-24 md:w-16 flex items-center justify-center">
                                        {star}{" "}
                                        <StarIcon sx={{ fontSize: "15px" }} />
                                      </span>
                                      <LinearProgress
                                        variant="determinate"
                                        value={
                                          ratingsData?.noOfRatings
                                            ? (ratingsData?.ratingCounts[star] /
                                                ratingsData?.noOfRatings) *
                                              100
                                            : 0
                                        }
                                        sx={{
                                          width: "100%",
                                          maxWidth: "500px",
                                          borderRadius: "4px",
                                          backgroundColor:
                                            star >= 4
                                              ? "#388e3c4a"
                                              : star === 3
                                              ? "#eea3004a"
                                              : "#d32f2f4a",
                                          "& .MuiLinearProgress-bar": {
                                            backgroundColor:
                                              star >= 4
                                                ? "#388e3c"
                                                : star === 3
                                                ? "#eea300"
                                                : "#d32f2f",
                                          },
                                        }}
                                        className="mx-2"
                                      />
                                      <span className="m-0 text-zinc-500">
                                        {ratingsData
                                          ? ratingsData.ratingCounts[star]
                                          : 0}
                                      </span>
                                    </Container>
                                  ))}
                                </Container>
                              </Container>
                            </Container>
                          )}
                        </Container>
                      </Container>
                    </Container>
                  </Container>
                )}
              </Container>
            )}

            {/* LOGIN MODAL */}
            <Modal
              open={loginModal}
              onClose={() => setIsLoginModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <p id="modal-modal-description">
                  Register Now to avail your discount on Bulk Gifting
                </p>
                <Container className="flex justify-end">
                  <Button
                    onClick={handleLoginPage}
                    className="bg-[#800000] px-6 py-1 rounded-lg text-white font-semibold active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
                  >
                    Login
                  </Button>
                </Container>
              </Box>
            </Modal>
          </Container>
        ) : (
          <Container className="min-h-[65vh] flex flex-col justify-center items-center">
            <NoInternetComp />
          </Container>
        )}
      </Container>
    </>
  );
}

export default ProductDetails;
